import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    loading: false,
    data:null
} 

export const GetLivChatLogDetails = createSlice({
    name: 'GetLivChatLogDetails',
    initialState,
    reducers: {
        initiateLoading: (state) => {
          state.loading = true
         },
        addSuccess: (state, action) => {
           state.loading = false;
            state.data = action.payload;
        },
        addFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload
        },
        resetData:(state,action)=>{
            state.loading = false;
            state.data = null; 
        }
    }
});

export const { addSuccess, addFailure,initiateLoading,resetData} = GetLivChatLogDetails.actions;

// Selectors
export const getLivChatLogDetailsList = (state) => {
    return state.GetLivChatLogDetails;
};

export default GetLivChatLogDetails.reducer;
